import QueryStringFactory from './QueryStringFactory';

(window.onpopstate = function () {
    window.queryString = QueryStringFactory.make(window.location.href);
})();

module.exports = QueryStringFactory;




// WEBPACK FOOTER //
// ./app/app.js